import { Component, OnInit } from '@angular/core';
import {ApiService} from "../../services/api.service";
import {ProductService} from "../../services/product.service";
import {QuestionService} from "../../services/question.service";
import { Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';

@Component({
    selector: 'analyse-result',
    templateUrl: './result.component.html'
})
export class AnalyseResultComponent implements OnInit {
    public form: FormGroup;

    public isLoading: boolean = true;
    public breadcrumbs = [{
        url: '/',
        label: 'Home'
    },{
        label: 'Resultaat huidanalyse'
    }];
    public collection: string[] = [];
    public excl: string[] = [];
    public queryTimeout: number = null;
    public query: string = '';
    public filters: Object[] = [];
    public ingredients_show: Object[] = null;
    public ingredients_show_negative: Object[] = null;
    public activeFilters: string[] = ApiService.readToken('activeFilters') ? ApiService.readToken('activeFilters').split(';') : [];
    public activePackaging: string[] = [ApiService.readToken('activePackaging')] || [];
    public activePrice: string[] = [ApiService.readToken('activePrice')] || [];
    public activeCategorie: string[] = [ApiService.readToken('activeCategorie')] || [];
    public activeQty: string[] = [ApiService.readToken('activeQty')] || [];
    public products: Object[] = null;
    public currentPage: number = 1;
    public totalPages: number = 0;
    public perPage: number = 10;    
    public activeProductId: string = '';
    public showAfterDiv: boolean = false;
    public showAfterDivFirst: boolean = false;
    public showBeforeDiv: boolean = true;
    public showStatusNotPaid: boolean = false;
    public testSmth: string = '';
    public categorie: Object[] = [{
        id: 'Gezichtscrème',
        name: 'Gezichtscrème'
    },{
        id: 'Gezichtsverzorging',
        name: 'Gezichtsverzorging'
    },{
        id: 'Huidverzorging',
        name: 'Huidverzorging'
    },{
        id: 'Lichaamsverzorging',
        name: 'Lichaamsverzorging'
    },{
        id: 'Reinigingsproduct',
        name: 'Reinigingsproduct'
    },{
        id: 'Serum',
        name: 'Serum'
    },{
        id: 'Zonbeschermingsproduct',
        name: 'Zonbeschermingsproduct'
    }];
    public packaging: Object[] = [{
        id: 'rectFzj9njrQBjfBx',
        name: 'Pot'
    },{
        id: 'recX09fKnVJABeTiP',
        name: 'Tube'
    },{
        id: 'recuAu9TC48ujYvzd',
        name: 'Pomp'
    },{
        id: 'recWibyofl6OW7J9E',
        name: 'Fles'
    },{
        id: 'recnyMhvBt4wApF01',
        name: 'Spray'
    },{
        id: 'recSU4mpMr480bjin',
        name: 'Ampul'
    }];
    public pricing: Object[] = [{
        id: '0,10',
        name: '€ 0 - € 10'
    },{
        id: '10,20',
        name: '€ 10 - € 20'
    },{
        id: '20,30',
        name: '€ 20 - € 30'
    },{
        id: '30,40',
        name: '€ 30 - € 40'
    },{
        id: '40,50',
        name: '€ 40 - € 50'
    },{
        id: '50,60',
        name: '€ 50 - € 60'
    },{
        id: '60,10000',
        name: '€ 60+'
    }];
    public qty: Object[] = [{
        id: '0,30',
        name: '0-30 ml'
    },{
        id: '30,60',
        name: '30-60 ml'
    },{
        id: '60,75',
        name: '60-75 ml'
    },{
        id: '75,100',
        name: '75-100 ml'
    },{
        id: '100,400',
        name: '100-400 ml'
    }];
    

    constructor(private fb: FormBuilder, private productService: ProductService, private questionService: QuestionService, private router: Router) { 
        this.form = fb.group({
            emailAddress: ['', Validators.compose([Validators.required,Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)])],
            name: ['', Validators.compose([Validators.required,Validators.minLength(2)])],
            results: ['', Validators.compose([Validators.required,Validators.maxLength(1)])],
            agree_one: ['', Validators.compose([Validators.required,Validators.maxLength(1)])],
            agree_two: ['', Validators.compose([Validators.required,Validators.maxLength(1)])]
        });
    }

    ngOnInit() {
        ApiService.eraseToken('activePackaging');
        ApiService.eraseToken('activeCategorie');
        ApiService.eraseToken('activePrice');
        ApiService.eraseToken('activeQty');
        ApiService.eraseToken('activeFilters');
        const currentAnswers = JSON.parse(ApiService.readToken('currentAnswers'));
        this.productService.analyse('answer-ingredients','',currentAnswers,{},{},{},'',{}, 1, 2).subscribe((response) => {
            this.ingredients_show = response.data || [];
            this.ingredients_show_negative = response.data_negative || [];
            if(response['data'] && response['data'].length > 0) {
                this.ingredients_show = response['data'];
            } 
            if(response['data_negative'] && response['data_negative'].length > 0) {
                this.ingredients_show_negative = response['data_negative'];
            } 
            
        });
        var url = window.location.href;
        if(url.includes('transaction_id')) {
            var url_data = url.split('=');
            if(url_data[1] != '') {
                var today = new Date(new Date().setDate(new Date().getDate()));
                var url_one = url_data[1].split('&status');
                ApiService.writeToken(today.getTime(),'paynl_date');
                ApiService.writeToken(url_one[0],'paynl_token');
                ApiService.writeToken(url_data[2],'paynl_status');
                window.history.replaceState(null, null, window.location.pathname);
            }   
        }
        var paynl_date = ApiService.readToken('paynl_date');
        var end_date = new Date(new Date().setDate(new Date().getDate()-7));
        if(parseInt(paynl_date) < end_date.getTime()) {
           ApiService.eraseToken('paynl_token');
            ApiService.eraseToken('paynl_status');
            ApiService.eraseToken('paynl_date');
        }
        var paynl_token = ApiService.readToken('paynl_token');
        var paynl_status = ApiService.readToken('paynl_status');
       
        if(paynl_status != null && paynl_status.length > 1 && paynl_status == 'not_paid') {
            this.showStatusNotPaid = true;
            this.showAfterDiv = false;
            this.showAfterDivFirst = false;
        }
        if(paynl_token != null && paynl_status != null && paynl_token.length > 1 && paynl_status.length > 1 && paynl_status == 'paid') {
            this.showAfterDiv = true;
            this.showAfterDivFirst = false;
            this.showBeforeDiv = false;
        }
        const collection = ApiService.readToken('collection');
        if(!this.collection.length && collection)
        {
            this.collection = collection.split(',');
        }
        

        const excl = ApiService.readToken('excl');
        if(!this.excl.length && excl)
        {
            this.excl = excl.split(',');
        }

        if(!this.collection.length)
        {
            this.navigate(['huidanalyse']);
        }

        this.questionService.getSections().subscribe((res) => {
            this.filters = res.data.filter((e) => { return e['filter'] == 1 });
            this.filters.forEach((o,i) =>{
                this.questionService.getQuestions(o['id']).subscribe((r) => {
                    this.filters[i]['questions'] = r.data;
                });
            });
        });
        this.get();
    }

    public get()
    {
        if(this.activeFilters.length != 0) {
            var activeFilters_new = this.activeFilters.filter(function (el) {
                return el != null && el != "";
            });
            ApiService.writeToken(activeFilters_new.join(';'),'activeFilters');
        } else {
            ApiService.eraseToken('activeFilters');
        }
        if(this.activePackaging.length != 0) {
            var activePackaging_new = this.activePackaging.filter(function (el) {
                return el != null && el != "";
            });
            ApiService.writeToken(activePackaging_new.join(';'),'activePackaging');
        } else {
            ApiService.eraseToken('activePackaging');
        }
        
        if(this.activePrice.length != 0) {
            var activePrice_new = this.activePrice.filter(function (el) {
                return el != null && el != "";
            });
            ApiService.writeToken(activePrice_new.join(';'),'activePrice');
        } else {
            ApiService.eraseToken('activePrice');
        }
        if(this.activeCategorie.length != 0) {
            var activeCategorie_new = this.activeCategorie.filter(function (el) {
                return el != null && el != "";
            });
            ApiService.writeToken(activeCategorie_new.join(';'),'activeCategorie');
        } else {
            ApiService.eraseToken('activeCategorie');
        }
        if(this.activeQty.length != 0) {
            var activeQty_new = this.activeQty.filter(function (el) {
                return el != null && el != "";
            });
            ApiService.writeToken(activeQty_new.join(';'),'activeQty');
        } else {
            ApiService.eraseToken('activeQty');
        }
        this.isLoading = true;
        const currentAnswers = JSON.parse(ApiService.readToken('currentAnswers'));
        this.productService.analyse(this.collection.join(','),this.excl.join(','),this.activePackaging,this.activePrice,this.activeCategorie,this.activeQty,this.query,this.activeFilters/*[0]*/, this.currentPage, this.perPage, currentAnswers).subscribe((res) => {
            this.products = res.data || [];
            this.isLoading = false;
            
                if(res['data'] && res['data'].length > 0)
                {
                    this.products = res['data'];
                    this.products.forEach(function(obj) {
                        obj['price'] = parseFloat(obj['Prijs'].replace(',','.'));
                    });

                    this.totalPages = Math.ceil(res['total']/this.perPage);
                    
                }            

        });
    }
    
    clearFilters()
    {
        this.activePackaging.length = 0;
        this.activeCategorie.length = 0;
        this.activePrice.length = 0;
        this.activeQty.length = 0;
        this.activeFilters.length = 0;
        
        ApiService.eraseToken('activeCategorie');
        ApiService.eraseToken('activePackaging');
        ApiService.eraseToken('activePrice');
        ApiService.eraseToken('activeQty');
        ApiService.eraseToken('activeFilters');
        this.get();
    }

    changePage(pageNum: number)
    {
        this.currentPage = pageNum;
        this.get();
    }    

    public navigate(commands: string[])
    {
        this.router.navigate(commands);
    }

    public updateQuery(e)
    {
        if(this.queryTimeout)
        {
            clearTimeout(this.queryTimeout)
        }
        this.queryTimeout = setTimeout(() => {
            this.get();
        },200);

    }

    public setActivePackaging(index: string, id: string)
    {
        if(this.activePackaging[index] != id)
        {
            this.activePackaging[index] = id;
        }
        else
        {
            this.activePackaging[index] = '';
        }
       
        ApiService.writeToken(this.activePackaging.join(';'),'activePackaging');
        this.get();
        
    }

    public setActiveCategorie(index: string, id: string)
    {
        if(this.activeCategorie[index] != id)
        {
            this.activeCategorie[index] = id;
        }
        else
        {
            this.activeCategorie[index] = '';
        }
        
        ApiService.writeToken(this.activeCategorie.join(';'),'activeCategorie');
        this.get();
    }

    public setActivePrice(index: string, id: string)
    {
        /*if(this.activePrice != id)
        {
            this.activePrice = id;
        }
        else
        {
            this.activePrice = '';
        }
        ApiService.writeToken(this.activePrice,'activePrice');*/
        if(this.activePrice[index] != id)
        {
            this.activePrice[index] = id;
        }
        else
        {
            this.activePrice[index] = '';
        }
        
        ApiService.writeToken(this.activePrice.join(';'),'activePrice');
        this.get();
    }

    public setActiveQty(index: string, id: string)
    {
        /*if(this.activeQty != id)
        {
            this.activeQty = id;
        }
        else
        {
            this.activeQty = '';
        }
        ApiService.writeToken(this.activeQty,'activeQty');*/
        if(this.activeQty[index] != id)
        {
            this.activeQty[index] = id;
        }
        else
        {
            this.activeQty[index] = '';
        }
        
        ApiService.writeToken(this.activeQty.join(';'),'activeQty');
        this.get();
    }

    public setActiveFilter(index: number, id: string)
    {
        if(this.activeFilters[index] != id)
        {
            this.activeFilters[index] = id;
        }
        else
        {
            this.activeFilters[index] = '';
        }
        
        ApiService.writeToken(this.activeFilters.join(';'),'activeFilters');
        this.get();
    }

    public showAfter() {
        this.showAfterDiv = false;
        this.showAfterDivFirst = true;
        this.showBeforeDiv = true;
    }

    public check_status() {
        window.location.href = "https://www.dermabase.nl/paynl.php?status=status&order_id="+ApiService.readToken('paynl_token')+"&orderId="+ApiService.readToken('paynl_token');
        return false;
    }

    submit() {
        if(this.form.value.agree_one === true && this.form.value.agree_two === true) {
            window.location.href = "https://www.dermabase.nl/paynl.php";
        } else {
            alert('You must agree to continue to payment!');
        }
        return false;
    }
}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/analyse/result.component.ts